import ArrayWithRemove from './ArrayWithRemove';

export default abstract class GenericArrayTreeNode<T extends ArrayWithRemove> {
	private _active: boolean;
	private _ArrayCtor: new () => T;
	private _nullArray: T;

	children: T;
	parent: GenericArrayTreeNode<T> | null;

	constructor (ArrayCtor: new () => T, nullArray: T) {
		this._active = true;
		this._ArrayCtor = ArrayCtor;
		this._nullArray = nullArray;

		this.children = nullArray;
		this.parent = null;
	}

	get active () {
		return this._active;
	}

	set active (active) {
		if (active === this._active) {
			return;
		}

		if (this.parent === null) {
			return;
		}

		if (active) {
			this.parent._addChild(this);
		} else {
			this.parent._removeChild(this);
		}
	}

	_addChild (child: GenericArrayTreeNode<T>) {
		if (this.children === this._nullArray) {
			this.children = new this._ArrayCtor();
		}
		this.children.push(child);
	}

	addChild (child: GenericArrayTreeNode<T>) {
		const parent = child.parent;
		if (parent !== null) {
			parent._removeChild(child);
		}
		child.parent = this;

		this._addChild(child);
		return this;
	}

	_removeChild (child: GenericArrayTreeNode<T>) {
		this.children.remove(child);
	}

	addToParent (parent: GenericArrayTreeNode<T>) {
		parent.addChild(this);
		return this;
	}

	removeFromParent () {
		if (this.parent === null) {
		  return;
		}
  
		this.parent._removeChild(this);
		this.parent = null;
		return this;
	 }

	 // TODO: remove (needs to fix some typing issues)
	_addInteractivePath (child: GenericArrayTreeNode<T>) {}
	_removeInteractivePath (child: GenericArrayTreeNode<T>) {}
	_repositionInteractivePath (child: GenericArrayTreeNode<T>) {}
}
